import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private _loading = signal(false);
    private _count = 0;

    /**
     * Read-only signal representing the global loading state.
     */
    readonly loading = this._loading.asReadonly();

    /**
     * Sets the global loading state with simple reference counting.
     * No delays to prevent render loops.
     * @param value True to indicate loading start, false to indicate stop.
     */
    set(value: boolean) {
        if (value) {
            this._count++;
            // Only set to true if not already true and this is the first request
            if (this._count === 1) {
                this._loading.set(true);
            }
        } else {
            this._count = Math.max(0, this._count - 1);
            // Only set to false when all requests are done
            if (this._count === 0) {
                this._loading.set(false);
            }
        }
    }

    /**
     * Helper to execute an async function with automatic loading state management.
     * @param asyncFn The asynchronous function to execute.
     */
    async withLoading<T>(asyncFn: () => Promise<T>): Promise<T> {
        this.set(true);
        try {
            return await asyncFn();
        } finally {
            this.set(false);
        }
    }
}

